import './tallguyandgrill/style';
import FormStructure from './tallguyandgrill/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/includes.js